$(document).ready(function () {
    const phoneInputs = document.querySelectorAll('input[type="tel"]');

    phoneInputs.forEach(input => {
        let dataFor = $(input).attr('data-for');
        const oldValue = $(input).attr('data-value');

        let country = 'au';
        let countryCode = '61';
        let phoneNumber = null;

        if (oldValue) {
            if (oldValue.search("\\+") === 0){
                country = null;
                countryCode = null;
                const getPhoneNumber = oldValue.split(' ');

                phoneNumber = getPhoneNumber[0].startsWith('+') ? getPhoneNumber[1] : getPhoneNumber[0];
                if (getPhoneNumber[0] && getPhoneNumber[0].length === 3 && getPhoneNumber[0].startsWith('+')) {
                    countryCode = getPhoneNumber[0].slice(1) ?? "";
                    if (countryCode == '61') {
                        country = 'au';
                    } else if (countryCode == '64') {
                        country = 'nz';
                    }
                } else {
                    country = 'au';
                    countryCode = 61;
                }
            }else{
                country = null;
                countryCode = null;
                phoneNumber = oldValue;
            }
        }

        let dataCodeEl = $(`.${dataFor}`);

        if (dataCodeEl) {
            dataCodeEl.val(countryCode);
        }

        const iti = intlTelInput(input, {
            utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@17.0.8/build/js/utils.js",
            onlyCountries: ['au', 'nz'],
            initialCountry: country,
        });

        const itiContainer = $(input).closest('.iti');

        setTimeout(() => {
            const selectedCountry = itiContainer.find('.iti__selected-country');
            selectedCountry.find('.iti__arrow')
                .html(`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10.8887 6.66663L7.88867 9.99996L4.88867 6.66663" stroke="#101828" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`);
            if (selectedCountry.length) {
                selectedCountry.find('.iti__arrow').after(`<div class="iti__selected-country-text">${countryCode ? '+' + countryCode : ''}</div>`);
            }
        }, 0);

        input.addEventListener('countrychange', function () {
            const countryData = iti.getSelectedCountryData();
            const countryCode = countryData.dialCode;
            if (dataCodeEl) {
                dataCodeEl.val(countryCode);
            }
            if (countryCode) {
                itiContainer.find('.iti__selected-country-text').text('+' + countryCode);
            }
        });

        input.addEventListener('input', function () {
            let value = $(this).val();
            if (value.length > 10) {
                $(this).val(value.substring(0, 10));
            }
            const countryData = iti.getSelectedCountryData();
            const countryCode = countryData.dialCode;
            if (dataCodeEl) {
                dataCodeEl.val(countryCode);
            }
            if (countryCode) {
                itiContainer.find('.iti__selected-country-text').text('+' + countryCode);
            }
        });

        if (phoneNumber) {
            iti.setNumber(phoneNumber);
        }
    });
});
